var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.37,27.22h-15.18v-3.8c0-6.29-5.1-11.39-11.39-11.39h-7.6c-6.29,0-11.39,5.1-11.39,11.39v3.8h-15.18c-2.1,0-3.8,1.7-3.8,3.8s1.7,3.79,3.8,3.79h3.79v37.97c0,8.39,6.8,15.19,15.19,15.19h22.78c8.39,0,15.19-6.8,15.19-15.19v-37.97h3.79c2.1,0,3.8-1.7,3.8-3.79s-1.7-3.8-3.8-3.8ZM42.41,23.42c0-2.1,1.7-3.79,3.79-3.79h7.6c2.1,0,3.79,1.7,3.79,3.79v3.8h-15.18v-3.8ZM68.98,72.78c0,4.19-3.4,7.59-7.59,7.59h-22.78c-4.19,0-7.59-3.4-7.59-7.59v-37.97h37.96v37.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeTrash);
export default __webpack_public_path__ + "static/media/acae_trash.fbe41185.svg";
export { ForwardRef as ReactComponent };